import React, { useState, useEffect } from 'react'
import { FaPizzaSlice } from 'react-icons/fa'
import Modal from '../../components/Modal'
import api from '../../services/api'

export default function BordasPorTamanho({
  modal,
  fecharModal,
  produto,
  setMontagemProdutos,
  NotificationManager,
  config,
}) {
  const [brotinho, setBrotinho] = useState(false)
  const [pequena, setPequena] = useState(false)
  const [media, setMedia] = useState(false)
  const [grande, setGrande] = useState(false)
  const [gigante, setGigante] = useState(false)
  const [big, setBig] = useState(false)
  const [familia, setFamilia] = useState(false)

  const salvar = async () => {
    await api
      .post('montagem-produtos/alterarTamanho', {
        Brotinho: Number(brotinho),
        Pequena: Number(pequena),
        Media: Number(media),
        Grande: Number(grande),
        Gigante: Number(gigante),
        Big: Number(big),
        Familia: Number(familia),
        Id: produto.Id,
      })
      .then((res) => {
        setMontagemProdutos((state) =>
          state.map((e) => {
            if (e.Id !== res.data.Id) {
              return e
            }
            e = res.data
            return e
          })
        )
        fecharModal()
        NotificationManager.info('Produto alterado')
      })
  }

  useEffect(() => {
    if (produto) {
      setBrotinho(Boolean(parseInt(produto.TBrotinho)))
      setPequena(Boolean(parseInt(produto.TPequena)))
      setMedia(Boolean(parseInt(produto.TMedia)))
      setGrande(Boolean(parseInt(produto.TGrande)))
      setGigante(Boolean(parseInt(produto.TGigante)))
      setBig(Boolean(parseInt(produto.TBig)))
      setFamilia(Boolean(parseInt(produto.TFamilia)))
    }
  }, [modal])

  return (
    <Modal open={modal} onClose={fecharModal}>
      <h5>
        <FaPizzaSlice color="#28a745" size={25} /> Bordas / Insumos
      </h5>
      <div className="d-flex justify-content-center">
        {config.UsaTamanhoBrotinho === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox1"
              checked={brotinho}
              onChange={() => setBrotinho(!brotinho)}
            />
            <label className="form-check-label" for="inlineCheckbox1">
              Brotinho
            </label>
          </div>
        )}
        {config.UsaTamanhoPequeno === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox2"
              checked={pequena}
              onChange={() => setPequena(!pequena)}
            />
            <label className="form-check-label" for="inlineCheckbox2">
              Pequena
            </label>
          </div>
        )}
        {config.UsaTamanhoMedia === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox3"
              checked={media}
              onChange={() => setMedia(!media)}
            />
            <label className="form-check-label" for="inlineCheckbox3">
              Média
            </label>
          </div>
        )}
        {config.UsaTamanhoGrande === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox4"
              checked={grande}
              onChange={() => setGrande(!grande)}
            />
            <label className="form-check-label" for="inlineCheckbox4">
              Grande
            </label>
          </div>
        )}
        {config.UsaTamanhoGigante === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox5"
              checked={gigante}
              onChange={() => setGigante(!gigante)}
            />
            <label className="form-check-label" for="inlineCheckbox5">
              Gigante
            </label>
          </div>
        )}
        {config.UsaTamanhoBig === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox6"
              checked={big}
              onChange={() => setBig(!big)}
            />
            <label className="form-check-label" for="inlineCheckbox6">
              Big
            </label>
          </div>
        )}
        {config.UsaTamanhoFamilia === 'True' && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox7"
              checked={familia}
              onChange={() => setFamilia(!familia)}
            />
            <label className="form-check-label" for="inlineCheckbox7">
              Familia
            </label>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-success btn-sm"
          onClick={salvar}
        >
          Salvar
        </button>
        <button
          type="button"
          className="btn btn-secondary btn-sm ml-1"
          onClick={fecharModal}
        >
          Fechar
        </button>
      </div>
    </Modal>
  )
}
